<template>
    <ur-modal ref="convModal" noFoot :title="$t('MSG_TIT_CONVERSATION')" dragable width="944px" @closed="resetVariable">
      <div class="modal_content modal_lg talk_history_detail_pop" >
       <div class="modal_header">
            <p class="modal_sub_title">{{convDataset.scheduleName}}</p>
            <div class="modal_info"><span class="time">{{convDate}} {{startTime}} ~ {{endTime}}</span><span class="tel">{{convDataset.calleeNumber}}</span></div>
       </div>
      
      <div :class="audioPlayerCls">
        <audio ref="audioPlayerInConv" muted="false" oncontextmenu="return false" id="audioInConv" @volumechange="onVolumeChange" @play = "onRecordPlay" @pause = "onRecordPause" controls :src="audioBlobUrl" type="audio/mpeg3" style="height:48px;" controlsList="nodownload noplaybackrate"/>
      </div>
      <div class="talk_search">
        <div v-if="indexFlag" class="search_index">
          (<strong>{{searchIndex}}</strong>/{{searchTotal}})
        </div>
        <custom-text-field   style="width:878px" v-model="searchText" clearable searchable @click-icon="onSearchText" @click-icon-clear="onClearText" @enter="onSearchText"/>
        
        <button type="button" class="btn_history_open" @click="onGoDown"></button>
        <button type="button" class="btn_history_close" @click="onGoUp"></button>
      </div>      
      
      <p class="talk_history_title"><span>{{convDataset.scenarioName}}</span></p>
      <div class="modal_body" style="height:500px">
        <div class="talk_history_detail" >
          <ul>
          <li v-for="data in conversationData">       
            <div class="question" v-if="data.msgFlag==='2'">
              <!--div :id="data.seq"> <p v-html="data.msg"></p></div-->
              <div :id="'chatInConv-'+data.seq"> <p v-html="data.msg"></p></div>
            </div>
            <div class="answer" v-else-if="data.msgFlag==='1'">
              <!--div :id="data.seq"><p v-html="data.msg"></p></div-->
              <div :id="'chatInConv-'+data.seq"><p v-html="data.msg"></p></div>
              <span class="msgtime"> {{data.msgTimeString}} </span>
            </div>
          </li>
          </ul>
        </div>
      </div>
      <div class="modal_footer">
        <div class="btn_left">
          <ur-button @click="onRecordingDownload">{{ $t("MSG_BTN_RECORD_DOWNLOAD") }}</ur-button>
          <ur-button @click="onTextDownload">{{ $t("MSG_BTN_TEXT_DOWNLOAD") }}</ur-button>
        </div>
        <ur-button solid primary @click="onConvModalclose">{{ $t("MSG_BTN_CFRM") }}</ur-button>
      </div>
      </div>
    </ur-modal>
</template>

<script>
import TreeItemWithIconVue from '../../../../samples/component-guide/Tree/TreeItemWithIcon.vue';
import customTextField from './CMP_AIC_00003_C01';

const TAG_REGEX = /(<([^>]+)>)/gi;

export default {
        name: 'ConversationModal',
        components:{
          customTextField:customTextField,
        },
        props:{
          convDataset : {
            type : Object,
                default() {
                    return {};
                },
            }
        },
        data() {
          return {
            convDate: '',
            startTime: '',
            endTime: '',
            conversationDataAsk: {
              requestId: '',
              outcallId: '',        
            },
            recordDataAsk: {
              sid: '',
            },
            searchText: '',
            counterText: '(0/0)',
            conversationDataOriginal: [],
            conversationData: [],
            conversationLength: 0,
            focusedText: {
              prevSeq: '',
              prevConversationSeq: '',
              focusedSeq: 0,
              conversationSeq: '',
              textIndex: '',
            },
            searchResults: [],
            audioBlobUrl: '',
            recordFilename: '',
            searchTotal: 0,
            searchIndex: 0,
            indexFlag:false,
            audioPlayerPaused: true,
              audioPlayerMuted: false,
              timer: '',
          };
        },
        computed:{
          audioPlayerCls() {
            let clazz = ['audio_player'];
            this.audioPlayerPaused ? clazz.push('play') : clazz.push('pause');
            this.audioPlayerMuted ? clazz.push('muted') : clazz.push('unmuted');
            return clazz;
          },
        },
        updated() {
          this.$nextTick(function () {
            if (this.conversationData.length > this.conversationLength) { // 추가된 대화가 있으면 스크롤을 마지막 대화로 이동
              this.conversationLength = this.conversationData.length;
              const seqid = `chatInConv-${this.conversationData.length - 1}`;
              const element = document.getElementById(seqid);
              element.scrollIntoView(false);
            }
          });
        },
        methods:{
          onVolumeChange(){
            this.audioPlayerMuted = this.$refs['audioPlayerInConv'].muted;
          },
          onRecordPlay(){
            this.audioPlayerPaused = false;
          },
          onRecordPause(){
            this.audioPlayerPaused = true;
          },
          getRecordFile(){
            http.request(this.convDataset.pageid, 'DTS_AIC_00021', {
              responseType: 'blob',
              query: this.recordDataAsk,
            }).then((response) => {
              if(response.data.size > 0){
                this.recordFilename = response.headers['content-disposition'].split('filename=')[1].split(';')[0];
                this.audioBlobUrl = aiccUtils.fileDownload.getBlobUrl(response.data, 'audio/mpeg');
                this.$refs['audioPlayerInConv'].src = this.audioBlobUrl;
              }
            });
          },
          open() {
            this.searchText = '';
            this.searchResults = [];
            this.conversationLength = 0;
            this.getConversationData();
            this.onClearText();
            this.$refs['convModal'].open();
            if (this.convDataset.itemStatus !== 'C') { // 통화가 종료되지 않았으면 대화 refresh
              this.timer = setInterval(this.getConversationData, 3000);
            }
          },
          resetAudio() {
            var audioElementInConv = this.$refs['audioPlayerInConv'];
            audioElementInConv.pause();
            audioElementInConv.currentTime = 0;
            audioElementInConv.src = "";
            audioElementInConv.load();
            this.audioBlobUrl = "";
            this.audioPlayerPaused = true;
          },
            resetVariable() {
                clearInterval(this.timer); 
            this.resetAudio();
            this.indexFlag = false;
            this.searchText = '';
            this.searchResults = [];
            this.messageList = [];
            this.conversationData = [];
            this.conversationDataOriginal = [];
            this.recordDataAsk.sid = '';
            this.conversationDataAsk.requestId = '';
            this.conversationDataAsk.outcallId = '';
          },
            onConvModalclose() {
                clearInterval(this.timer);  
            this.resetVariable();
            this.$refs['convModal'].close();
          },
          getConversationData(){
            // console.log(this.convDataset);
            this.conversationDataAsk.requestId = this.convDataset.scheduleId;
            this.conversationDataAsk.outcallId = this.convDataset.itemIndex;
            // console.log(this.conversationDataAsk);
            const orgData = [];
            var seq = 0;

            // 상단 대화시간 표시 위해 셋팅
            this.convDate = utils.toStringByFormat(this.convDataset.conversationTime, "YYYY-MM-DD");
            this.startTime = utils.toStringByFormat(this.convDataset.startTime, "HH:mm:ss");
            this.endTime = utils.toStringByFormat(this.convDataset.endTime, "HH:mm:ss");

            http.request(this.convDataset.pageid, 'DTS_AIC_00017', {
              query: this.conversationDataAsk,
            }).then((response) => {
              // console.log(JSON.stringify(response.data));
              utils.forEach(response.data.list, obj => {
                if(obj.msgFlag === '3'){ return;} // session manager
                const objData = {
                  seq: seq++,
                  msgSeq: obj.msgSeq,
                  msgFlag: obj.msgFlag,
                  // 메시지 내 tag 제거
                  msg: obj.msg.replaceAll(TAG_REGEX, ''),
                  msgTime: aiccUtils.conversationDownload.changeTimeZoneAndFormat(obj.msgTime),
                  msgTimeString: aiccUtils.conversationDownload.changeTimeZoneAndFormat(obj.msgTime, 'HH:mm:ss'),
                  sessionId : obj.sessionId,
                }
                orgData.push(objData);
              });
              
              this.conversationDataOriginal = orgData;
              this.conversationData = this.setOriginalDataset();
              if(response.data.list.length > 0){
                this.recordDataAsk.sid = response.data.list[0].sessionId;
              }

              if (response.data.itemStatus === 'C') { // 통화가 종료되면 대화 refresh 중단
                clearInterval(this.timer);
              }
            }).then(() => {
              if (this.convDataset.itemStatus === 'C') { // 통화가 종료된 경우에만 녹취파일 조회
                this.getRecordFile();
              }
            });
            
          },
          setOriginalDataset(){
            // console.log("originalDataset");
            const originalDataset = [];
            this.conversationDataOriginal.forEach(data => {
              const newData = {
                seq : data.seq,
                msgSeq : data.msgSeq,
                msgFlag: data.msgFlag,
                msg: data.msg,
                msgTime: data.msgTime,
                msgTimeString: data.msgTimeString,
                sessionId : data.sessionId,
              }
              originalDataset.push(newData);
            })
            // console.log(originalDataset);
            return originalDataset;
          },
          onTextDownload(){
            const sToday = utils.now('YYYYMMDDHHmmss');
            const sCsvName = `conv_history_${sToday}.csv`;

            var conversationDataParam = [];
            var convkey = this.convDataset.scheduleId+'_'+this.convDataset.itemIndex;
            conversationDataParam[convkey] = this.conversationDataOriginal;
            var convDatasetParam = [];
            convDatasetParam.push(this.convDataset);
            let historyData = {
              pageId : 'ConversationModal',
              fileName : sCsvName,
              fileDetail : `Request ID : ${this.convDataset.scheduleId} / Outcall Id : ${this.convDataset.itemIndex}`,
            }
            // 다운로드 이력 남기기
            http.request(this.convDataset.pageid, 'DTS_AIZ_00001', {
              data: historyData,
            }).then((res) => {
              if (res.status === 200) {
                aiccUtils.conversationDownload.makeConversationFileWithData(sCsvName, convDatasetParam, conversationDataParam);
              } else {
                utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
              }
            });
          },
          onRecordingDownload(){
            if(this.audioBlobUrl.length <= 0){
              return;
            }
            let historyData = {
              pageId : 'ConversationModal',
              fileName : this.recordFilename,
              fileDetail : `Session ID : ${this.recordDataAsk.sid}`,
            }
            // 다운로드 이력 남기기
            http.request(this.convDataset.pageid, 'DTS_AIZ_00001', {
              data: historyData,
            }).then((res) => {
              if (res.status === 200) {
                aiccUtils.fileDownload.download(this.audioBlobUrl, this.recordFilename);
              } else {
                utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
              }
            });
          },
          onClearText(){
            // console.log("onClearText");
            this.searchText = '';
            this.searchIndex = 0;
            this.indexFlag = false;
            this.conversationData = this.setOriginalDataset();
            // console.log(this.conversationData);
          },
          onSearchText(){
            // 검색어 공백 제거
            this.searchText = this.searchText.trim();
            var messageList = [];
            this.indexFlag = true;
            this.searchIndex = 0;
            if(this.searchText.length === 0){
              this.onClearText();
              return;
            }
            this.conversationData = [];
            this.conversationData = this.setOriginalDataset();
            // console.log(this.conversationData);

            for(let index in this.conversationDataOriginal) {
              let tempData = this.conversationDataOriginal[index];
              var position = 0;
              do {
                var searchindex = tempData.msg.indexOf(this.searchText, position);
                // console.log(searchindex);
                if(searchindex !== -1) {
                  const researchInfo = {
                    seq: tempData.seq,
                    index: searchindex,
                  }
                  messageList.push(researchInfo);
                  position = searchindex+1;
                }
              }while(searchindex !== -1);
              
              let resultText = '<span class="highlight_d">'+this.searchText+'</span>'
              this.conversationData[index].msg = tempData.msg.replaceAll(this.searchText, resultText);
            }
            // console.log(this.conversationData);
            // console.log(this.conversationDataOriginal);
            if(messageList.length > 0) {
              // console.log(messageList.length);
              this.focusedText.prevSeq = 0;
              this.focusedText.prevConversationSeq = 0;
              this.focusedText.focusedSeq = 0;
              this.focusedText.conversationSeq = messageList[0].seq;
              this.focusedText.textIndex = messageList[0].index;
              this.searchIndex = 1;
              this.goSection(1);
            }
            this.searchResults = messageList;
            this.searchTotal = this.searchResults.length;
            
          },
          goSection(fStart){
            // fStart == 1 이면 검색 후 첫 이동으로 원복 없음.
            // hightlight 원복 및 변환
            let resultTextBack = '<span class="highlight_d">'+this.searchText+'</span>'
            let resultText = '<span class="highlight">'+this.searchText+'</span>'
            if(fStart !== 1){
              // seq 0이면 첫 하이라이트라 원복 없음
              let tempPrev = this.conversationDataOriginal[this.focusedText.prevConversationSeq];
              this.conversationData[this.focusedText.prevConversationSeq].msg = tempPrev.msg.replaceAll(this.searchText, resultTextBack);
            }
            let tmpMsg = '';
            let temp = this.conversationDataOriginal[this.focusedText.conversationSeq];
            var position = 0;
            do {
                var searchindex = temp.msg.indexOf(this.searchText, position);
                // console.log(searchindex);
                if(searchindex !== -1) {
                  tmpMsg = tmpMsg + temp.msg.substring(position, searchindex);
                  if(searchindex === this.focusedText.textIndex){
                    tmpMsg = tmpMsg +  resultText;
                  }else{
                    tmpMsg = tmpMsg + resultTextBack;
                  }
                  position = searchindex + this.searchText.length;
                }
              }while(searchindex !== -1);
            if(position !== temp.msg.length){
              tmpMsg = tmpMsg + temp.msg.substring(position);
            }
            this.conversationData[this.focusedText.conversationSeq].msg = tmpMsg;

            // console.log(this.conversationData);
            // console.log(this.conversationDataOriginal);

            //var element = document.getElementById(this.focusedText.conversationSeq);
            //var element = this.$refs['charInConv-'+this.focusedText.conversationSeq];
            let seqid = 'chatInConv-'+this.focusedText.conversationSeq;
            var element = document.getElementById(seqid);
            element.scrollIntoView(true);
          },
          onGoUp(){
            // console.log("onGoUp");
            if(this.focusedText.focusedSeq > 0) {
              this.focusedText.prevSeq = this.focusedText.focusedSeq;
              this.focusedText.prevConversationSeq = this.searchResults[this.focusedText.prevSeq].seq;
              var focusedSeq = --this.focusedText.focusedSeq;
              this.focusedText.conversationSeq = this.searchResults[focusedSeq].seq;
              this.focusedText.textIndex = this.searchResults[focusedSeq].index;
              this.searchIndex = this.focusedText.focusedSeq+1;
              this.goSection(0);
            }
          },
          onGoDown(){
            // console.log("onGoDown");
            if(this.focusedText.focusedSeq < (this.searchTotal - 1)) {
              this.focusedText.prevSeq = this.focusedText.focusedSeq;
              var prevSeq = this.focusedText.prevSeq;
              this.focusedText.prevConversationSeq = this.searchResults[prevSeq].seq;
              var focusedSeq = ++this.focusedText.focusedSeq;
              this.focusedText.conversationSeq = this.searchResults[focusedSeq].seq;
              this.focusedText.textIndex = this.searchResults[focusedSeq].index;
              this.searchIndex = this.focusedText.focusedSeq+1;
              this.goSection(0);
            }
          },
        }
    }
</script>

<style scoped>

</style>